<div class="modal-container">
  <div mat-dialog-title class="title">Impostazioni Slot</div>
  <mat-dialog-content class="mat-typography">
    <div class="inner-section">
      @for (item of slotsOrari; let i = $index; track i) {
        <div class="flex-time">
          <div class="time-table-flex">
            <label>Dalle:</label>
            <select
              [(ngModel)]="item.start_time"
              [disabled]="!!item.id_event_slot"
            >
              @for (ora of orari; track ora) {
                <option [value]="ora">{{ ora }}</option>
              }

            </select>
          </div>

          <div class="time-table-flex">
            <label>Alle:</label>
            <select
              [(ngModel)]="item.end_time"
              [disabled]="!!item.id_event_slot"
            >
              @for (ora of orari; track ora) {
                <option [value]="ora">{{ ora }}</option>
              }
            </select>
          </div>

          <div class="time-table-flex">
            <label>Capacità:</label>
            <input
              name="eventCapacity"
              id="eventCapacity"
              type="number"
              [min]="minCapacity[i] ? minCapacity[i] : 0"
              max="100"
              [(ngModel)]="item.max_users"
              autocomplete="off"
              required
            />
          </div>

          @if (data.isSpaCategory) {
            <div class="time-table-flex" >
              <label>Dettaglio:</label>
              <input
                name="dettaglio"
                id="dettaglio"
                type="text"
                [(ngModel)]="item.detail"
                autocomplete="off"
              />
            </div>
          }

          <button
            class="my-button confirm small"
            mat-raised-button
            (click)="removeSlot(i)"
          >
            <mat-icon>remove</mat-icon>
          </button>

        </div>
      }


      <div style="padding: 20px">
        <button
          class="my-button confirm small"
          mat-raised-button
          (click)="addSlot()"
          [disabled]="!allSlotsValid()"
        >
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
  @if (minSlotError) {
    <p class="error" id="errorName">Errore:</p>
    <br />
    <span style="font-size: 16px; color: #20623b; display: flex">
      {{ minSlotError }}
    </span>
  }
  @if (!(slotsOrari.length == 1 && slotsOrari[0].start_time == null)) {
    @for (error of errors; track error) {
      <p class="error" id="errorName">Errore:</p>
      <br />
      <span style="font-size: 16px; color: #20623b; display: flex">
        {{ error }}
      </span>
    }
  }
  </mat-dialog-content>

  <mat-dialog-actions align="end" style="margin-top: 10px">
    <button class="my-button back" mat-raised-button (click)="close()">
      ANNULLA
    </button>
    <button
      class="my-button confirm"
      mat-raised-button
      (click)="save()"
      [disabled]="!allSlotsValid()"
    >
      CONTINUA
    </button>
  </mat-dialog-actions>
</div>
